import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const ModalBody = ({ children, scrollable = true }) => {
  return <div className={classNames("et--modal-body", { "et--modal-body-scrollable": scrollable })}>{children}</div>;
};

ModalBody.propTypes = {
  children: PropTypes.any,
  scrollable: PropTypes.bool,
};

export default ModalBody;
